module.exports = __webpack_public_path__ + "img/tuan1-1.74983159.png";